// use "click" or "hover" to control the sitenav dropdowns
const DROPDOWN_MOUSEEVENT = "hover";
const EVENT_NODE_SELECTOR = "#portal-globalnav > li.has_subtree";

const DropdownTabs = {

    async init() {

        var $dropdown_tabs = $("#portal-globalnav > li.has_subtree > a");

        function close_dropdown(tab, drop) {
            drop.removeClass("active");
            tab.removeClass("active");
            $("body").removeClass("globalnav-expanded");
        }
        $(EVENT_NODE_SELECTOR).bind(
            DROPDOWN_MOUSEEVENT === "hover" ? "mouseenter" : "click",
            (e) => {
                e.preventDefault();

                var this_tab = $(e.target),
                    this_dropdown = this_tab.siblings(".dropdown"),
                    all_dropdowns = $("#portal-globalnav > li > .dropdown");

                if (!this_dropdown.hasClass("active")) {
                    // open dropdown
                    if (!$("body").hasClass("globalnav-expanded")) {
                        $("body").addClass("globalnav-expanded");
                    }
                    // hide possible other opened dropdown
                    all_dropdowns.removeClass("active");
                    $dropdown_tabs.removeClass("active");
                    this_dropdown.addClass("active");
                    this_tab.addClass("active");
                } else {
                    // close opened item (only for click event)
                    close_dropdown(this_tab, this_dropdown);
                }
            }
        );

        // mouseout logic
        if(DROPDOWN_MOUSEEVENT === "hover") {
            $(EVENT_NODE_SELECTOR).bind("mouseleave", (e) => {
                var tab_container = $(e.delegateTarget),
                    this_dropdown = $(".dropdown", tab_container),
                    this_tab = $(".nav-link", tab_container);
                close_dropdown(this_tab, this_dropdown);
            });
        }
    }

};

export default DropdownTabs;
